import * as React from "react";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { Box } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { authStore } from "../../../features/auth/store/AuthStore";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor: "#1C2536",
  flexDirection: "row",
  color: "white",
  "& .MuiAccordionSummary-expandIconWrapper": {
    color: "#9DA4AE",
  },
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    color: "#9DA4AE",
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(1),
}));

const getActiveColor = ({
  pathname,
  pattern,
  regularColor,
  activeColor,
}: {
  pathname: string;
  pattern: RegExp;
  regularColor: string;
  activeColor: string;
}) => {
  if (pattern.test(pathname)) {
    return activeColor;
  } else return regularColor;
};

export const CustomAccordion = observer(() => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [expanded, setExpanded] = React.useState<string | false>(false);
  const { toggleMenu } = React.useContext(authStore);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  React.useEffect(() => {
    if (/^\/(fast-views)/.test(pathname)) {
      setExpanded("panel1");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <div>
      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
      >
        <AccordionSummary
          aria-controls="panel1d-content"
          id="panel1d-header"
          sx={{ display: "flex", alignItems: "center" }}
        >
          <RemoveRedEyeOutlinedIcon
            sx={{
              mr: "8px",
              height: "24px",
              color: getActiveColor({
                pathname,
                pattern: /^\/(fast-views)/,
                regularColor: "#9DA4AE",
                activeColor: "rgb(158, 119, 237)",
              }),
            }}
          />
          <Typography
            sx={{
              color: getActiveColor({
                pathname,
                pattern: /^\/(fast-views)/,
                regularColor: "#9DA4AE",
                activeColor: "#fff",
              }),
              fontSize: "14px",
              lineHeight: "24px",
              fontWeight: "600",
            }}
          >
            {t("fastViews")}
          </Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            backgroundColor: "#1C2536",
            color: "#9DA4AE",
            px: "16px",
            py: "6px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                height: "24px",
                width: "24px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mx: "8px",
              }}
            >
              <Box
                sx={{
                  height: "6px",
                  width: "6px",
                  borderRadius: "50%",
                  backgroundColor: getActiveColor({
                    pathname,
                    pattern: /orders/,
                    regularColor: "none",
                    activeColor: "rgb(158, 119, 237)",
                  }),
                }}
              ></Box>
            </Box>
            <Link
              to={"/fast-views/orders"}
              onClick={() => toggleMenu(false)}
              style={{ textDecoration: "none", flex: 1 }}
            >
              {" "}
              <Typography
                sx={{
                  color: getActiveColor({
                    pathname,
                    pattern: /orders/,
                    regularColor: "#9DA4AE",
                    activeColor: "#fff",
                  }),
                  fontSize: "13px",
                  lineHeight: "24px",
                  fontWeight: "500",
                  mr: "8px",
                }}
              >
                {t("orders")}
              </Typography>
            </Link>
          </Box>
        </AccordionDetails>
        <AccordionDetails
          sx={{
            backgroundColor: "#1C2536",
            color: "#9DA4AE",
            px: "16px",
            py: "6px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                height: "24px",
                width: "24px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mx: "8px",
              }}
            >
              <Box
                sx={{
                  height: "6px",
                  width: "6px",
                  borderRadius: "50%",
                  backgroundColor: getActiveColor({
                    pathname,
                    pattern: /prices/,
                    regularColor: "none",
                    activeColor: "rgb(158, 119, 237)",
                  }),
                }}
              ></Box>
            </Box>
            <Link
              to={"/fast-views/prices"}
              onClick={() => toggleMenu(false)}
              style={{ textDecoration: "none", flex: 1 }}
            >
              {" "}
              <Typography
                sx={{
                  color: getActiveColor({
                    pathname,
                    pattern: /prices/,
                    regularColor: "#9DA4AE",
                    activeColor: "#fff",
                  }),
                  fontSize: "13px",
                  lineHeight: "24px",
                  fontWeight: "500",
                  mr: "8px",
                }}
              >
                {t("prices.prices")}
              </Typography>
            </Link>
          </Box>
        </AccordionDetails>
        {/* <AccordionDetails
          sx={{
            backgroundColor: "#1C2536",
            color: "#9DA4AE",
            px: "16px",
            py: "6px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                height: "24px",
                width: "24px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mx: "8px",
              }}
            >
              <Box
                sx={{
                  height: "6px",
                  width: "6px",
                  borderRadius: "50%",
                  backgroundColor: getActiveColor({
                    pathname,
                    pattern: /plan/,
                    regularColor: "none",
                    activeColor: "rgb(158, 119, 237)",
                  }),
                }}
              ></Box>
            </Box>
            <Link
              to={"/fast-views/plan"}
              onClick={() => toggleMenu(false)}
              style={{ textDecoration: "none", flex: 1 }}
            >
              {" "}
              <Typography
                sx={{
                  color: getActiveColor({
                    pathname,
                    pattern: /plan/,
                    regularColor: "#9DA4AE",
                    activeColor: "#fff",
                  }),
                  fontSize: "13px",
                  lineHeight: "24px",
                  fontWeight: "500",
                  mr: "8px",
                }}
              >
                Plan
              </Typography>
            </Link>
          </Box>
        </AccordionDetails> */}
        <AccordionDetails
          sx={{
            backgroundColor: "#1C2536",
            color: "#9DA4AE",
            px: "16px",
            py: "6px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                height: "24px",
                width: "24px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mx: "8px",
              }}
            >
              <Box
                sx={{
                  height: "6px",
                  width: "6px",
                  borderRadius: "50%",
                  backgroundColor: getActiveColor({
                    pathname,
                    pattern: /api-keys/,
                    regularColor: "none",
                    activeColor: "rgb(158, 119, 237)",
                  }),
                }}
              ></Box>
            </Box>
            <Link
              to={"/fast-views/api-keys"}
              onClick={() => toggleMenu(false)}
              style={{ textDecoration: "none", flex: 1 }}
            >
              {" "}
              <Typography
                sx={{
                  color: getActiveColor({
                    pathname,
                    pattern: /api-keys/,
                    regularColor: "#9DA4AE",
                    activeColor: "#fff",
                  }),
                  fontSize: "13px",
                  lineHeight: "24px",
                  fontWeight: "500",
                  mr: "8px",
                }}
              >
                {t("API")}
              </Typography>
            </Link>
          </Box>
        </AccordionDetails>
      </Accordion>
    </div>
  );
});
